export enum SnackbarType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
